import { mapMutations, mapActions, mapState } from 'vuex'
import {
  genericGetRequestToApi,
  genericDeleteRequestToApi
} from '../../utils/genericRequests'
import { RetrieveProfileUrl } from '../../utils/agentUrls'
import {
  RetrieveProfileById,
  UpdateDeleteFavoriteUrl
} from '../../utils/clientUrls'
import { getFavoriteObjectFromPropertyId } from '../../utils/propertyUtils'
import {
  createFavoriteProperty,
  getPropertyById,
  requestTourRequest
} from '../../services/propertiesService'

export default {
  data() {
    return {
      displayFavWarning: false,
      modalParams: {
        title: 'That property is already added to your favorite list',
        btnText: 'Ok'
      },
      disableFavorite: false
    }
  },

  computed: {
    ...mapState('client', ['clientData', 'clientFavorites']),
    ...mapState('common', ['profileStatus'])
  },

  methods: {
    ...mapActions('client', [
      'clientHomeDetailsAction',
      'fetchClientMessagesAction',
      'clientRouteDataAction',
      'updateSingleFavorite'
    ]),
    ...mapActions('common', ['getRouteData', 'profileLogout']),

    ...mapMutations('client', {
      setClientData: 'SET_CLIENT_DATA',
      setPreferenceList: 'SET_PREFERENCE_LIST',
      setAssociatedAgent: 'SET_ASSOCIATED_AGENT',
      updateClientFavorites: 'UPDATE_CLIENT_FAVORITES',
      setClientFavorites: 'SAVE_CLIENT_FAVORITES'
    }),
    ...mapMutations('agent', {
      updatePropertiesData: 'UPDATE_PROPERTIES_DATA'
    }),
    ...mapMutations('common', {
      setLoadingRoutes: 'SET_LOADING_ROUTES'
    }),

    async getClientData(retrieveProperties = false) {
      this.setLoadingRoutes(true)
      const response = await genericGetRequestToApi(RetrieveProfileUrl())
      if (response.status === 200) {
        this.setClientData(response.data)
        this.clientRouteDataAction(response.data)
        this.setPreferenceList()
        if (response.data.current_agentid) {
          const agentResponse = await genericGetRequestToApi(RetrieveProfileById(
            response.data.current_agentid))
          this.setAssociatedAgent(agentResponse.data)
        }
        this.getRouteData({ data: response.data, type: 'client' })
        this.fetchClientMessagesAction()
        if (retrieveProperties) {
          this.clientHomeDetailsAction(response.data)
        }
      } else if (response.status === 401) {
        this.profileLogout()
      }
    },

    async removeFromFavorites({ propertyId, isTourRequested }) {
      if (isTourRequested === false) {
        const homeObject = getFavoriteObjectFromPropertyId(
          this.clientData.homes,
          propertyId
        )
        const response = await genericDeleteRequestToApi(
          UpdateDeleteFavoriteUrl(this.clientData._id, homeObject._id)
        )
        if (response.status === 200) {
          const updatedHomes = this.clientData.homes.filter(
            home => home.propertyId !== propertyId
          )
          this.setClientData(
            { ...this.clientData, homes: updatedHomes }
          )
          const updatedFavs = this.clientFavorites.filter(
            fav => fav._id !== propertyId
          )
          this.setClientFavorites(updatedFavs)
          if (this.profileStatus === 'agent') {
            this.updatePropertiesData({
              clientId: this.clientData._id,
              propertyData: updatedFavs
            })
          }
        }
      }
    },

    async setFavorite(propertyId, propertyDetail = null) {
      this.disableFavorite = true
      const response = await createFavoriteProperty(
        this.clientData._id,
        propertyId
      )
      if (response.status === 201) {
        if (!propertyDetail) {
          propertyDetail = (await getPropertyById(propertyId)).data
        }
        let isAdded = false
        for (const home in this.clientData.homes) {
          if (home.propertyId === response.data.propertyId) isAdded = true
        }
        if (!isAdded) {
          const updatedFavProperty = {
            ...propertyDetail,
            ...response.data,
            favoriteId: response.data._id,
            _id: propertyDetail._id
          }
          this.setClientData(
            { ...this.clientData, home: [...this.clientData.homes, response.data] }
          )
          const updatedProperties = [
            ...this.clientFavorites,
            updatedFavProperty
          ]
          this.setClientFavorites(updatedProperties)
          if (this.profileStatus === 'agent') {
            this.updatePropertiesData({
              clientId: this.clientData._id,
              propertyData: updatedProperties
            })
          }
        }
      } else if (response.status === 409) {
        this.displayFavWarning = true
      }
      this.disableFavorite = false
      return response.data
    },

    async requestTourForProperty(propertyObject) {
      const response = await requestTourRequest(
        this.clientData._id,
        propertyObject._id
      )

      if (response.status === 200) {
        const clientHomes = this.clientData.homes.map(home => {
          return home._id === propertyObject._id
            ? { ...propertyObject, requestTour: true }
            : home
        })
        const updatedProperties = this.clientFavorites.map(fav => {
          return fav._id === propertyObject.propertyId
            ? { ...fav, requestTour: true }
            : fav
        })
        this.setClientData({ ...this.clientData, homes: clientHomes })
        this.setClientFavorites(updatedProperties)
        if (this.profileStatus === 'agent') {
          this.updatePropertiesData({
            clientId: this.clientData._id,
            propertyData: updatedProperties
          })
        }
      }
      return response.data
    }
  }
}
